<template lang="pug">
.padding
    h5._300.margin Trading Area
    
    .box
        v-server-table(
            ref="datatable" 
            :url="api" 
            :name="tableName" 
            :columns="columns" 
            :options="options"
        )

            template(slot="outlets" slot-scope="props")
                collection-counter(
                    label="name"
                    :subject="`${trans('general.outlets_assigned')}`"
                    :collection="props.row.outlets"
                )

    trading-area-form(ref="tradingAreaForm")

</template>

<script>
import Auth from '@js/plugins/auth';
import tradingAreaForm from './trading-area-form.vue';
import eventTradingArea from './trading-area-event';
import CollectionCounter from '@js/components/collection-counter';

export default {
    components: {
        tradingAreaForm,
        CollectionCounter,
    },
    data() {
        let canManageTradingArea = Auth.hasPermissionTo(
            'franchise_manage_trading_area',
        );

        let actionButtons = [
            {
                title: 'Create Trading Area',
                action: () => {
                    this.showTradingArea(null);
                },
            },
        ];

        if (!canManageTradingArea) {
            actionButtons = [];
        }

        return {
            tableName: 'VUETABLE_TRADING_AREA',
            columns: ['name', 'outlets'],
            options: {
                checkbox: canManageTradingArea,
                sortable: ['name'],

                rowClickCallback: row => {
                    this.showTradingArea(row.id);
                },

                rowClassCallback: () => 'pointer',

                actionButtons: actionButtons,

                checkbox_actions: {
                    api_delete: Laroute.route('franchise.trading_area.delete'),
                    delete_title: 'Delete Trading Area',
                },

                headings: {
                    outlets: this.trans('general.outlets'),
                },
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('franchise.trading_area.index');
        },
    },

    mounted() {
        this.registerEvent();
    },

    methods: {
        showTradingArea(id) {
            this.$refs.tradingAreaForm.$emit('show-trading-area', id);
        },

        registerEvent() {
            this.$refs.tradingAreaForm.$on('trading-area-saved', () => {
                this.$refs.datatable.getData();
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/trading-area/trading-area-list.vue